"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = require("babel-runtime/helpers/slicedToArray");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AnalyticsController = function () {
  function AnalyticsController(AnalyticsService, $q) {
    "ngInject";

    (0, _classCallCheck3.default)(this, AnalyticsController);
    this.analyticsService = AnalyticsService;
    this.$q = $q;
  }

  (0, _createClass3.default)(AnalyticsController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;

      this.isLoading = true;

      var getBotStatsPromise = this.analyticsService.getBotStatsData();

      this.$q.all([getBotStatsPromise]).then(function (data) {
        var _data = (0, _slicedToArray3.default)(data, 1),
            getBotStatsResponse = _data[0];

        _this.setBotStatsOptions(getBotStatsResponse);

        _this.isLoading = false;
      });
    }
  }, {
    key: "setBotStatsOptions",
    value: function setBotStatsOptions(data) {
      var eventStats = data.series[0];
      var titleFormat = kendo.format("{0} - Events: {1}", eventStats.name, eventStats.totalCount);
      var labelFormat = "#= category # - #= kendo.format('{0:p0}', value) # \n #=kendo.format('{0:n0} Events', dataItem.value)#";
      this.botEventsOptions = this.analyticsService.getDonutChartOptions(eventStats, titleFormat, labelFormat);
    }
  }]);
  return AnalyticsController;
}();

exports.default = AnalyticsController;


/** WEBPACK FOOTER **
 ** ./client/app/containers/analytics-bot/analytics-bot.controller.js
 **/